enum AuthStateKeysEnum {
  CurrentUser = 'auth:currentUser',
  EsiaCodeVerification = 'auth:esiaCodeVerification',
}

export default AuthStateKeysEnum;
